import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  CssBaseline,
  Drawer,
  List,
  ListItemText,
  Box,
  IconButton,
  Collapse,
  Avatar,
  Tooltip,
  ListItemButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
} from "@mui/material";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PaymentsIcon from "@mui/icons-material/Payments";
import AssignmentIcon from "@mui/icons-material/Assignment";
import MedicationIcon from "@mui/icons-material/Medication";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import SystemUpdateAltRoundedIcon from "@mui/icons-material/SystemUpdateAltRounded";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import KeyboardDoubleArrowLeftRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftRounded";
import KeyboardDoubleArrowRightRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowRightRounded";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import Bills from "../../components/userDashboard/Bills";
import DoctorManagement from "../../components/DoctorManagement/DoctorManagement";
import TestManagement from "../../components/TestManagement/TestManagement";
import Pathology from "../../components/LabReporting/Pathology/Pathology";
import Radiology from "../../components/LabReporting/Radiology/RadiologyReporting";
import MicroBiology from "../../components/LabReporting/MicroBiology/MicroBiology";
import PeopleIcon from "@mui/icons-material/People";
import ReceiptIcon from "@mui/icons-material/Receipt";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import ScienceIcon from "@mui/icons-material/Science";
import BiotechIcon from "@mui/icons-material/Biotech";
import CoronavirusIcon from "@mui/icons-material/Coronavirus";
import logo from "../../images/PULSE.png";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import Invoices from "../../components/Invoices/Invoices";
import PathologyReports from "../../components/LabReports/PathologyReports";
import RadiologyReports from "../../components/LabReports/RadiologyReports";
import RadarIcon from "@mui/icons-material/Radar";
import DeblurIcon from "@mui/icons-material/Deblur";
import SummarizeIcon from "@mui/icons-material/Summarize";
import PendingReports from "../../components/pendingReports/PendingReports";
import LogoutIcon from "@mui/icons-material/Logout";
import LockResetIcon from "@mui/icons-material/LockReset";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { authState } from "../../recoil/authAtom";
import { userPageHeaderState } from "../../recoil/navigationAtom";
import DoctorConsult from "../../components/userDashboard/DoctorConsult";
import {
  getAuthUser,
  getSessionType,
  getUserPermissions,
  isPermission,
} from "../../utils/auth";
import Patient from "../../components/PatientManagement/Patient";
import MicrobiologyReports from "../../components/LabReports/MicrobiologyReports";
import Chat from "../Chat/Chat";
import DashboardInformation from "./DashboardInformation";
import { APP_VERSION, BASE_URL } from "../../constants";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import RefPatientList from "../../components/userDashboard/RefPatientList";
import PatientPrescriptionForm from "../prescription/PatientPrescriptionForm";
import DoctorPatientList from "../prescription/DoctorPatientList";
import MedicineMaster from "../prescription/MedicineMaster";
import PrescriptionList from "../PrescriptionRecords/Prescription";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import MicrobiologyReportsDynamics from "../../components/LabReports/MicrobiologyReportsDynamic";
import Accounting from "../Accounting";
import Ledger from "../Ledger";
import ManualVouchers from "../ManualVouchers";
import { logout as logoutSession } from "../../utils/api";
import { io } from "socket.io-client";
import Overview from "../Overview";
import Products from "../Products";
import Bom from "../Bom";
import Receipt from "../Receipt";
import CycleCount from "../CycleCount";
const parentNavWidth = 88;
const drawerWidth = 336;
const getAppVersion = (payload) => {
  if (typeof payload === "number" || typeof payload === "string") {
    return payload;
  }

  return payload?.appVersion ?? payload?.data?.appVersion;
};

const pageHeaderByPath = {
  "/dashboard": {
    navLink: "Dashboard",
    header: "Dashboard",
    subtitle: "An overview of your lab and clinic activity.",
    icon: DashboardIcon,
  },
  "/dashboard/patients": {
    navLink: "Patient Management",
    header: "Patient Management",
    subtitle: "Manage patient records, visits, and clinical information.",
    icon: PeopleIcon,
  },
  "/dashboard/bills": {
    navLink: "Bill Management",
    header: "Bill Management",
    subtitle: "Create, review, and manage patient billing.",
    icon: ReceiptIcon,
  },
  "/dashboard/doctors": {
    navLink: "Doctor Management",
    header: "Doctor Management",
    subtitle: "Manage doctors and their consultation details.",
    icon: MedicalServicesIcon,
  },
  "/dashboard/opd": {
    navLink: "OPD Management",
    header: "OPD Management",
    subtitle: "Coordinate outpatient consultations and appointments.",
    icon: AssignmentIndIcon,
  },
  "/dashboard/prescription": {
    navLink: "Prescription",
    header: "Digital Prescription",
    subtitle: "Create clear, complete prescriptions for your patients.",
    icon: AssignmentIcon,
  },
  "/dashboard/patient": {
    navLink: "Patients",
    header: "Patients",
    subtitle: "View scheduled patients and start prescriptions.",
    icon: PeopleIcon,
  },
  "/dashboard/prescription-list": {
    navLink: "Prescription Records",
    header: "Prescription Records",
    subtitle: "Review previously issued digital prescriptions.",
    icon: AssignmentIcon,
  },
  "/dashboard/medicine": {
    navLink: "Medicine",
    header: "Medicine Master",
    subtitle: "Maintain the medicines available for prescriptions.",
    icon: MedicationIcon,
  },
  "/dashboard/test": {
    navLink: "Test Management",
    header: "Test Management",
    subtitle: "Configure tests, methods, and reporting ranges.",
    icon: ScienceIcon,
  },
  "/dashboard/invoices": {
    navLink: "Invoices",
    header: "Invoices",
    subtitle: "View and manage generated invoices.",
    icon: FileCopyIcon,
  },
  "/dashboard/lab/pathology": {
    navLink: "Pathology",
    header: "Pathology Reporting",
    subtitle: "Record and finalize pathology test results.",
    icon: BiotechIcon,
  },
  "/dashboard/lab/radiology": {
    navLink: "Radiology",
    header: "Radiology Reporting",
    subtitle: "Create radiology reports with diagnostic findings.",
    icon: RadarIcon,
  },
  "/dashboard/lab/microbiology": {
    navLink: "Microbiology",
    header: "Microbiology Reporting",
    subtitle: "Document microbiology observations and results.",
    icon: CoronavirusIcon,
  },
  "/dashboard/report/pathology": {
    navLink: "Pathology",
    header: "Pathology Reports",
    subtitle: "Review completed pathology reports.",
    icon: SummarizeIcon,
  },
  "/dashboard/report/radiology": {
    navLink: "Radiology",
    header: "Radiology Reports",
    subtitle: "Review completed radiology reports.",
    icon: SummarizeIcon,
  },
  "/dashboard/report/microbiology": {
    navLink: "Microbiology",
    header: "Microbiology Reports",
    subtitle: "Review completed microbiology reports.",
    icon: SummarizeIcon,
  },
  "/dashboard/pending-approvals": {
    navLink: "Pending Approvals",
    header: "Pending Approvals",
    subtitle: "Review items that need your approval.",
    icon: PendingActionsIcon,
  },
  "/dashboard/ledger": {
    navLink: "Ledger A/C",
    header: "Ledger A/C",
    subtitle: "Review account activity and voucher history.",
    icon: ContactMailIcon,
  },
  "/dashboard/bill-settlement": {
    navLink: "Bill Settlement",
    header: "Bill Settlement",
    subtitle: "Record and manage invoice settlements.",
    icon: ReceiptLongIcon,
  },
  "/dashboard/centre-ref": {
    navLink: "Centre Referrals",
    header: "Centre Referrals",
    subtitle: "Manage patient referrals from associated centres.",
    icon: GroupAddIcon,
  },
  "/dashboard/manualVouchers": {
    navLink: "Manual Vouchers",
    header: "Manual Vouchers",
    subtitle: "Create and maintain manual accounting vouchers.",
    icon: RequestQuoteIcon,
  },
};

// Keep this component at module scope. Defining route wrappers inside
// UserDashboard creates a new component type on every navbar state change,
// which remounts the active page and repeats its API-loading effects.
const PermissionRoute = ({ allowed, children }) =>
  isPermission(allowed) ? children : <Navigate to="/dashboard" replace />;

const DoctorOnlyRoute = ({ children }) => {
  const auth = useRecoilValue(authState);
  const isDoctorSession =
    getSessionType(auth) === "doctor" ||
    sessionStorage.getItem("litss_doctor_session") === "true";

  return isDoctorSession ? children : <Navigate to="/dashboard" replace />;
};

const UserDashboard = () => {
  const user = useRecoilValue(authState);
  const setAuth = useSetRecoilState(authState);
  const userDetails = getAuthUser(user);
  const permissions = getUserPermissions(user);
  const isDoctorSession =
    user?.isDoctorSession === true ||
    user?.sessionType === "doctor" ||
    sessionStorage.getItem("litss_doctor_session") === "true";
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [pageHeader, setPageHeader] = useRecoilState(userPageHeaderState);
  const userName = localStorage.getItem("userName") || "User";
  const orgName = localStorage.getItem("orgName") || "Organization";
  const orgLogo = localStorage.getItem("orgLogo");
  const userInitial = userName.trim().charAt(0).toUpperCase() || "U";

  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [activeParentMenu, setActiveParentMenu] = useState("workspace");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const activeDrawerWidth = sidebarCollapsed ? parentNavWidth : drawerWidth;

  const handleProfileMenuOpen = (event) => {
    setProfileMenuAnchor(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setProfileMenuAnchor(null);
  };

  const handleProfileKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleProfileMenuOpen(event);
    }
  };
  useEffect(() => {
    setPageHeader(
      pageHeaderByPath[location.pathname] ?? {
        navLink: "",
        header: "",
        subtitle: "",
        icon: null,
      },
    );
  }, [location.pathname, setPageHeader]);

  useEffect(() => {
    const socket = io(BASE_URL, {
      transports: ["websocket"],
    });

    const checkAppVersion = (payload) => {
      const databaseVersion = Number(getAppVersion(payload));

      if (Number.isFinite(databaseVersion)) {
        setUpdateAvailable(databaseVersion !== APP_VERSION);
      }
    };

    // The server may publish the version as either `appVersion` or
    // `app-version`. Both events carry `{ appVersion: <number> }`.
    socket.on("appVersion", checkAppVersion);
    socket.on("app-version", checkAppVersion);

    return () => {
      socket.off("appVersion", checkAppVersion);
      socket.off("app-version", checkAppVersion);
      socket.disconnect();
    };
  }, []);

  const handleDrawerToggle = () => {
    if (!mobileOpen) {
      setSidebarCollapsed(false);
    }
    setMobileOpen(!mobileOpen);
  };

  const handleNavigate = (path) => {
    navigate(path);
  };

  const drawerItems = [
    {
      text: "Dashboard",
      path: "/dashboard",
      icon: <DashboardIcon />,
    },
    {
      text: "Patients",
      path: "/dashboard/patient",
      icon: <PeopleIcon />,
      display: isDoctorSession ? "" : "none",
    },
    {
      text: "Patient Management",
      path: "/dashboard/patients",
      icon: <PeopleIcon />,
      display: permissions?.patientManagement?.view ? "" : "none",
    },
    {
      text: "Bill Management",
      path: "/dashboard/bills",
      icon: <ReceiptIcon />,
      display: permissions?.billManagement?.create ? "" : "none",
    },
    {
      text: "Doctor Management",
      path: "/dashboard/doctors",
      icon: <MedicalServicesIcon />,
      display: permissions?.doctorManagement?.view ? "" : "none",
    },
    {
      text: "OPD Management",
      path: "/dashboard/opd",
      icon: <AssignmentIndIcon />,
      display: permissions?.opdManagement?.view ? "" : "none",
    },
    {
      text: "Prescription",
      path: "/dashboard/prescription",
      icon: <AssignmentIcon />,
      display: isDoctorSession ? "" : "none",
    },
    {
      text: "Medicine",
      path: "/dashboard/medicine",
      icon: <MedicationIcon />,
      display: permissions?.digitalPrescriptionManagement?.create ? "" : "none",
    },
    {
      text: "Test Management",
      path: "/dashboard/test",
      icon: <ScienceIcon />,
    },
    {
      text: "Invoices",
      path: "/dashboard/invoices",
      icon: <FileCopyIcon />,
      display: permissions?.billManagement?.view ? "" : "none",
    },
    {
      text: "Lab Reportings",
      icon: <BiotechIcon />,
      isDropdown: true,
      subItems: [
        {
          text: "Pathology",
          path: "/dashboard/lab/pathology",
          display: permissions?.pathologyManagement?.create ? "" : "none",
        },
        {
          text: "Radiology",
          path: "/dashboard/lab/radiology",
          display: permissions?.radiologyManagement?.create ? "" : "none",
        },
        {
          text: "Microbiology",
          path: "/dashboard/lab/microbiology",
          display: permissions?.microbiologyManagement?.create ? "" : "none",
        },
      ],
    },
    {
      text: "Lab Reports",
      icon: <SummarizeIcon />,
      isDropdown: true,
      subItems: [
        {
          text: "Pathology",
          path: "/dashboard/report/pathology",
          display: permissions?.pathologyManagement?.view ? "" : "none",
        },
        {
          text: "Radiology",
          path: "/dashboard/report/radiology",
          display: permissions?.radiologyManagement?.view ? "" : "none",
        },
        {
          text: "Microbiology",
          path: "/dashboard/report/microbiology",
          display: permissions?.microbiologyManagement?.view ? "" : "none",
        },
      ],
    },
    {
      text: "Pending Approvals",
      path: "/dashboard/pending-approvals",
      icon: <PendingActionsIcon />,
    },
    // {
    //   text: "Ledger A/C",
    //   path: "/dashboard/ledger",
    //   icon: <ContactMailIcon />,
    //   display: "",
    // },
    // {
    //   text: "Bill Settlement",
    //   path: "/dashboard/bill-settlement",
    //   icon: <ReceiptLongIcon />,
    //   display: "",
    // },
    {
      text: "Centre Referrals",
      path: "/dashboard/centre-ref",
      icon: <GroupAddIcon />,
    },
    // {
    //   text: "Manual Vouchers",
    //   path: "/dashboard/manualVouchers",
    //   icon: <RequestQuoteIcon />,
    //   display: "",
    // },
  ];

  const drawerItemsAccounts = [
    {
      text: "Ledger A/C",
      path: "/dashboard/ledger",
      icon: <ContactMailIcon />,
      display: "",
    },
    {
      text: "Bill Settlement",
      path: "/dashboard/bill-settlement",
      icon: <ReceiptLongIcon />,
      display: "",
    },

    {
      text: "Manual Vouchers",
      path: "/dashboard/manualVouchers",
      icon: <RequestQuoteIcon />,
      display: "",
    },
  ];
  const visibleDrawerItems = isDoctorSession
    ? drawerItems.filter((item) =>
        ["Patients", "Prescription"].includes(item.text),
      )
    : drawerItems;
  const dummyNavItems = [
    {
      text: "Overview",
      path: "/dashboard/overview",
      icon: <DashboardIcon />,
    },
    {
      text: "Products",
      path: "/dashboard/products",
      icon: <Inventory2OutlinedIcon />,
    },
    {
      text: "Suppliers",
      path: "/dashboard/suppliers",
      icon: <AccountTreeOutlinedIcon />,
    },
    {
      text: "Receipt",
      path: "/dashboard/receipt",
      icon: <ReceiptLongOutlinedIcon />,
    },
    {
      text: "Cycle Count",
      path: "/dashboard/cycle-count",
      icon: <FactCheckOutlinedIcon />,
    },
  ];
  const [openDropdowns, setOpenDropdowns] = useState({});

  // Keep the parent submenu expanded when a nested route is opened directly
  // or restored by a browser reload.
  useEffect(() => {
    const activeDropdown = drawerItems.find(
      (item) =>
        item.isDropdown &&
        item.subItems.some((subItem) => subItem.path === location.pathname),
    );
    if (!activeDropdown) return;

    setOpenDropdowns((previous) =>
      previous[activeDropdown.text]
        ? previous
        : { ...previous, [activeDropdown.text]: true },
    );
  }, [location.pathname]);

  const toggleDropdown = (item) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [item.text]: !prev[item.text],
    }));
  };

  const logout = async () => {
    await logoutSession();
    setAuth(null);
    navigate("/user-login", {
      replace: true,
    });
  };
  const getCurrentUser = () => {
    const _id = localStorage.getItem("userId");
    const userName = localStorage.getItem("userName");
    const orgName = localStorage.getItem("orgName");
    const orgEmail = localStorage.getItem("orgEmail");
    if (!_id || !userName || !orgName) return null;

    return {
      _id,
      userName,
      organization: {
        orgName,
        orgEmail,
      },
    };
  };
  const currentUser = getCurrentUser();
  console.log("currentUser ", currentUser);
  console.log("isDoctorSession ", isDoctorSession);

  if (
    isDoctorSession &&
    !["/dashboard/prescription", "/dashboard/patient"].includes(
      location.pathname,
    )
  ) {
    return <Navigate to="/dashboard/patient" replace />;
  }

  const drawer = (
    <Box
      sx={{
        width: activeDrawerWidth,
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        background:
          "linear-gradient(160deg, #f8faff 0%, #ffffff 48%, #f5f7ff 100%)",
        display: "flex",
        zIndex: 10000,
        borderRight: "1px solid #e5ecf7",
        boxShadow: "8px 0 32px rgba(25, 62, 170, 0.06)",
        transition: "width 240ms cubic-bezier(.2,.8,.2,1)",
      }}
    >
      {/* ── Parent navigation rail ── */}
      <Box
        sx={{
          width: parentNavWidth,
          flexShrink: 0,
          bgcolor: "#f4f7ff",
          borderRight: "1px solid #e1e8f6",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: 1.25,
          gap: 0.75,
        }}
      >
        {/* <Box
          sx={{
            width: 46,
            height: 46,
            p: "6px",
            borderRadius: "13px",
            bgcolor: "#fff",
            border: "1px solid #dce5f8",
            boxShadow: "0 5px 14px rgba(25,62,170,.10)",
            mb: 1,
          }}
        >
          <img
            src={logo}
            alt="PULSE"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </Box> */}

        <IconButton
          aria-label={
            sidebarCollapsed ? "Expand navigation" : "Collapse navigation"
          }
          onClick={() => setSidebarCollapsed((collapsed) => !collapsed)}
          sx={{
            display: { xs: "none", sm: "inline-flex" },
            width: 34,
            height: 34,
            mb: 0.45,
            border: "1px solid #dce5f8",
            color: "#3157c9",
            bgcolor: "rgba(255,255,255,.8)",
            boxShadow: "0 3px 10px rgba(25,62,170,.08)",
            "&:hover": {
              bgcolor: "#3157c9",
              color: "#fff",
              transform: "scale(1.04)",
            },
            transition: "all .2s ease",
          }}
        >
          {sidebarCollapsed ? (
            <KeyboardDoubleArrowRightRoundedIcon fontSize="small" />
          ) : (
            <KeyboardDoubleArrowLeftRoundedIcon fontSize="small" />
          )}
        </IconButton>

        {[
          {
            id: "workspace",
            label: "WS",
            name: "Workspace",
            icon: <AppsOutlinedIcon />,
          },
          {
            id: "accounts",
            label: "Accounts",
            name: "Accounts",
            icon: <AccountBalanceOutlinedIcon />,
          },
          {
            id: "tools",
            label: "Tools",
            name: "Tools",
            icon: <ExtensionOutlinedIcon />,
          },
        ].map((menu) => {
          const selected = activeParentMenu === menu.id;

          return (
            <Box
              component="button"
              type="button"
              onClick={() => setActiveParentMenu(menu.id)}
              sx={{
                width: 58,
                minHeight: 56,
                // px: 0.5,
                // py: 0.85,
                border: "none",
                borderRadius: "12px",
                cursor: "pointer",
                color: selected ? "#fff" : "#62738d",
                bgcolor: selected ? "#3157c9" : "transparent",
                boxShadow: selected ? "0 6px 14px rgba(49,87,201,.24)" : "none",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 0.45,
                font: "inherit",
                transition: "all .2s ease",
                "&:hover": {
                  bgcolor: selected ? "#2548af" : "#e7edfb",
                  color: selected ? "#fff" : "#173b9d",
                },
                "& svg": { fontSize: "1.35rem" },
              }}
            >
              {menu.icon}
              <Typography
                component="span"
                sx={{ fontSize: ".58rem", fontWeight: 700, lineHeight: 1.1 }}
              >
                {menu.label}
              </Typography>
            </Box>
          );
        })}
      </Box>

      {/* ── Active parent-menu panel ── */}
      <Box
        sx={{
          width: drawerWidth - parentNavWidth,
          minWidth: 0,
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          opacity: sidebarCollapsed ? 0 : 1,
          transform: sidebarCollapsed ? "translateX(-10px)" : "translateX(0)",
          pointerEvents: sidebarCollapsed ? "none" : "auto",
          transition: "opacity 150ms ease, transform 240ms ease",
        }}
      >
        {/* ── Logo ── */}
        <Box
          sx={{
            px: 2.25,
            py: 0,
            minHeight: 65,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            background: "rgba(255,255,255,0.72)",
            flexShrink: 0,
            position: "relative",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "1px",
              background:
                "linear-gradient(90deg, transparent, #9db1f5, transparent)",
            },
          }}
        >
          <Box
            sx={{
              width: 48,
              height: 48,
              p: "6px",
              borderRadius: "14px",
              background: "#ffffff",
              border: "1px solid #e3eafa",
              boxShadow: "0 8px 20px rgba(25, 62, 170, 0.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <img
              src={logo}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: "1.15rem",
                fontWeight: 800,
                letterSpacing: "1.5px",
                background: "linear-gradient(135deg, #173b9d, #7356d8)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                lineHeight: 1.1,
              }}
            >
              PULSE
            </Typography>
            <Typography
              sx={{
                fontSize: "0.6rem",
                color: "#75829a",
                letterSpacing: "0.65px",
                textTransform: "uppercase",
                mt: "2px",
              }}
            >
              Lab & Clinic System
            </Typography>
          </Box>
        </Box>

        {/* ── Nav Items ── */}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            px: 1.35,
            py: 1.75,
            // maxHeight: "calc(100vh - 200px)",
            "&::-webkit-scrollbar": { width: "3px" },
            "&::-webkit-scrollbar-track": { background: "transparent" },
            "&::-webkit-scrollbar-thumb": {
              background: "rgba(49,87,201,0.25)",
              borderRadius: "4px",
            },
          }}
        >
          {activeParentMenu === "workspace" && (
            <>
              <Typography
                sx={{
                  px: 1.15,
                  pb: 0.9,
                  color: "#8090aa",
                  fontSize: "0.67rem",
                  fontWeight: 800,
                  letterSpacing: "0.9px",
                }}
              >
                WORKSPACE
              </Typography>
              <List dense disablePadding>
                {visibleDrawerItems.map((item) =>
                  item.isDropdown ? (
                    <React.Fragment key={item.text}>
                      <ListItemButton
                        onClick={() => toggleDropdown(item)}
                        sx={{
                          borderRadius: "12px",
                          px: 1.5,
                          py: 0.9,
                          mb: 0.4,
                          color: openDropdowns[item.text]
                            ? "#173b9d"
                            : "#53627a",
                          background: openDropdowns[item.text]
                            ? "#eaf0ff"
                            : "transparent",
                          border: openDropdowns[item.text]
                            ? "1px solid #d6e0fa"
                            : "1px solid transparent",
                          "&:hover": {
                            background: "#f0f4ff",
                            color: "#173b9d",
                            border: "1px solid #dfe7fa",
                          },
                          transition: "all 0.2s ease",
                        }}
                      >
                        <Box
                          sx={{
                            color: openDropdowns[item.text]
                              ? "#3157c9"
                              : "#8493aa",
                            display: "flex",
                            alignItems: "center",
                            fontSize: "0.75rem",
                          }}
                        >
                          {item.icon}
                        </Box>
                        <ListItemText
                          sx={{ ml: 1 }}
                          primary={item.text}
                          primaryTypographyProps={{
                            fontSize: "0.75rem",
                            fontWeight: openDropdowns[item.text] ? 600 : 400,
                            color: "inherit",
                          }}
                        />
                        <Box sx={{ color: "#92a1b8", display: "flex" }}>
                          {openDropdowns[item.text] ? (
                            <ExpandLess fontSize="small" />
                          ) : (
                            <ExpandMore fontSize="small" />
                          )}
                        </Box>
                      </ListItemButton>

                      <Collapse
                        in={openDropdowns[item.text]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List
                          component="div"
                          disablePadding
                          sx={{ pl: 1.5, mb: 0.5 }}
                        >
                          <Box sx={{ position: "relative" }}>
                            {/* Vertical connector line */}
                            <Box
                              sx={{
                                position: "absolute",
                                left: "11px",
                                top: 0,
                                bottom: 0,
                                width: "1.5px",
                                background:
                                  "linear-gradient(180deg, #6f8ce4, rgba(49,87,201,0.12))",
                                borderRadius: "2px",
                              }}
                            />
                            {item.subItems.map((sub) => (
                              <ListItemButton
                                key={sub.text}
                                onClick={() => handleNavigate(sub.path)}
                                sx={{
                                  borderRadius: "8px",
                                  px: 1.5,
                                  py: 0.65,
                                  mb: 0.25,
                                  ml: 1,
                                  display: sub.display,
                                  color:
                                    location.pathname === sub.path
                                      ? "#ffffff"
                                      : "#667792",
                                  background:
                                    location.pathname === sub.path
                                      ? "linear-gradient(120deg, #193eaa, #5f51cc)"
                                      : "transparent",
                                  "&:hover": {
                                    background:
                                      location.pathname === sub.path
                                        ? "linear-gradient(120deg, #193eaa, #5f51cc)"
                                        : "#edf2ff",
                                    color:
                                      location.pathname === sub.path
                                        ? "#ffffff"
                                        : "#173b9d",
                                  },
                                  transition: "all 0.2s ease",
                                }}
                              >
                                <Box
                                  sx={{
                                    color:
                                      location.pathname === sub.path
                                        ? "rgba(255,255,255,0.85)"
                                        : "#8493aa",
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "0.75rem",
                                  }}
                                >
                                  {sub.icon}
                                </Box>
                                <ListItemText
                                  sx={{ ml: 1 }}
                                  primary={sub.text}
                                  primaryTypographyProps={{
                                    fontSize: "0.78rem",
                                    fontWeight:
                                      location.pathname === sub.path
                                        ? 600
                                        : 400,
                                    color: "inherit",
                                  }}
                                />
                              </ListItemButton>
                            ))}
                          </Box>
                        </List>
                      </Collapse>
                    </React.Fragment>
                  ) : (
                    <React.Fragment key={item.text}>
                      <ListItemButton
                        onClick={() => navigate(item.path)}
                        sx={{
                          borderRadius: "12px",
                          px: 1.5,
                          py: 0.9,
                          mb: 0.4,
                          display:
                            userDetails?.organizationId?.orgID !== "18-3" &&
                            permissions?.billManagement?.create &&
                            permissions?.patientManagement?.create &&
                            permissions?.opdManagement?.create &&
                            item.text === "Centre Referrals"
                              ? "none"
                              : item.display,
                          color:
                            item.text === "Centre Referrals"
                              ? location.pathname === item.path
                                ? "#ffffff"
                                : "#3157c9"
                              : location.pathname === item.path
                                ? "#ffffff"
                                : "#53627a",
                          background:
                            item.text === "Centre Referrals"
                              ? location.pathname === item.path
                                ? "linear-gradient(120deg, #193eaa, #5f51cc)"
                                : "#eaf0ff"
                              : location.pathname === item.path
                                ? "linear-gradient(120deg, #193eaa, #5f51cc)"
                                : "transparent",
                          border:
                            item.text === "Centre Referrals"
                              ? "1px solid #d6e0fa"
                              : location.pathname === item.path
                                ? "1px solid transparent"
                                : "1px solid transparent",
                          "&:hover": {
                            background:
                              location.pathname === item.path
                                ? "linear-gradient(120deg, #193eaa, #5f51cc)"
                                : item.text === "Centre Referrals"
                                  ? "#eaf0ff"
                                  : "#f0f4ff",
                            color:
                              location.pathname === item.path
                                ? "#ffffff"
                                : "#173b9d",
                            border:
                              location.pathname === item.path
                                ? "1px solid transparent"
                                : item.text === "Centre Referrals"
                                  ? "1px solid #d6e0fa"
                                  : "1px solid #dfe7fa",
                          },
                          transition: "all 0.2s ease",
                        }}
                      >
                        <Box
                          sx={{
                            color:
                              item.text === "Centre Referrals"
                                ? location.pathname === item.path
                                  ? "rgba(255,255,255,0.9)"
                                  : "#3157c9"
                                : location.pathname === item.path
                                  ? "rgba(255,255,255,0.9)"
                                  : "#8493aa",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {item.icon}
                        </Box>
                        <ListItemText
                          sx={{ ml: 1 }}
                          primary={item.text}
                          primaryTypographyProps={{
                            fontSize: "0.75rem",
                            fontWeight:
                              location.pathname === item.path ? 600 : 400,
                            color: "inherit",
                          }}
                        />
                        {/* Active indicator */}
                        {location.pathname === item.path &&
                          item.text !== "Centre Referrals" && (
                            <Box
                              sx={{
                                width: 5,
                                height: 5,
                                borderRadius: "50%",
                                background: "rgba(255,255,255,0.8)",
                                flexShrink: 0,
                              }}
                            />
                          )}
                      </ListItemButton>
                    </React.Fragment>
                  ),
                )}
              </List>
            </>
          )}
          {activeParentMenu === "tools" && (
            <>
              <Typography
                sx={{
                  px: 1.15,
                  pb: 0.9,
                  color: "#8090aa",
                  fontSize: "0.67rem",
                  fontWeight: 800,
                  letterSpacing: "0.9px",
                }}
              >
                TOOLS
              </Typography>
              <List dense disablePadding>
                {dummyNavItems.map((item) => (
                  <ListItemButton
                    key={item.text}
                    onClick={() => navigate(item.path)}
                    sx={{
                      borderRadius: "12px",
                      px: 1.5,
                      py: 0.9,
                      mb: 0.4,
                      color:
                        location.pathname === item.path ? "#ffffff" : "#53627a",
                      background:
                        location.pathname === item.path
                          ? "linear-gradient(120deg, #193eaa, #5f51cc)"
                          : "transparent",
                      border:
                        location.pathname === item.path
                          ? "1px solid transparent"
                          : "1px solid transparent",
                      "&:hover": {
                        background:
                          location.pathname === item.path
                            ? "linear-gradient(120deg, #193eaa, #5f51cc)"
                            : "#f0f4ff",
                        color:
                          location.pathname === item.path
                            ? "#ffffff"
                            : "#173b9d",
                        border:
                          location.pathname === item.path
                            ? "1px solid transparent"
                            : "1px solid #dfe7fa",
                      },
                      transition: "all 0.2s ease",
                    }}
                  >
                    <Box
                      sx={{
                        color:
                          location.pathname === item.path
                            ? "#ffffff"
                            : "#8493aa",
                        display: "flex",
                      }}
                    >
                      {item.icon}
                    </Box>
                    <ListItemText
                      sx={{ ml: 1 }}
                      primary={item.text}
                      primaryTypographyProps={{
                        fontSize: "0.75rem",
                        fontWeight: 600,
                      }}
                    />
                  </ListItemButton>
                ))}
              </List>
            </>
          )}
          {activeParentMenu === "accounts" && (
            <>
              <Typography
                sx={{
                  px: 1.15,
                  pb: 0.9,
                  color: "#8090aa",
                  fontSize: "0.67rem",
                  fontWeight: 800,
                  letterSpacing: "0.9px",
                }}
              >
                ACCOUNTS
              </Typography>
              <List dense disablePadding>
                {drawerItemsAccounts.map((item) =>
                  item.isDropdown ? (
                    <React.Fragment key={item.text}>
                      <ListItemButton
                        onClick={() => toggleDropdown(item)}
                        sx={{
                          borderRadius: "12px",
                          px: 1.5,
                          py: 0.9,
                          mb: 0.4,
                          color: openDropdowns[item.text]
                            ? "#173b9d"
                            : "#53627a",
                          background: openDropdowns[item.text]
                            ? "#eaf0ff"
                            : "transparent",
                          border: openDropdowns[item.text]
                            ? "1px solid #d6e0fa"
                            : "1px solid transparent",
                          "&:hover": {
                            background: "#f0f4ff",
                            color: "#173b9d",
                            border: "1px solid #dfe7fa",
                          },
                          transition: "all 0.2s ease",
                        }}
                      >
                        <Box
                          sx={{
                            color: openDropdowns[item.text]
                              ? "#3157c9"
                              : "#8493aa",
                            display: "flex",
                            alignItems: "center",
                            fontSize: "0.75rem",
                          }}
                        >
                          {item.icon}
                        </Box>
                        <ListItemText
                          sx={{ ml: 1 }}
                          primary={item.text}
                          primaryTypographyProps={{
                            fontSize: "0.75rem",
                            fontWeight: openDropdowns[item.text] ? 600 : 400,
                            color: "inherit",
                          }}
                        />
                        <Box sx={{ color: "#92a1b8", display: "flex" }}>
                          {openDropdowns[item.text] ? (
                            <ExpandLess fontSize="small" />
                          ) : (
                            <ExpandMore fontSize="small" />
                          )}
                        </Box>
                      </ListItemButton>

                      <Collapse
                        in={openDropdowns[item.text]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List
                          component="div"
                          disablePadding
                          sx={{ pl: 1.5, mb: 0.5 }}
                        >
                          <Box sx={{ position: "relative" }}>
                            {/* Vertical connector line */}
                            <Box
                              sx={{
                                position: "absolute",
                                left: "11px",
                                top: 0,
                                bottom: 0,
                                width: "1.5px",
                                background:
                                  "linear-gradient(180deg, #6f8ce4, rgba(49,87,201,0.12))",
                                borderRadius: "2px",
                              }}
                            />
                            {item.subItems.map((sub) => (
                              <ListItemButton
                                key={sub.text}
                                onClick={() => handleNavigate(sub.path)}
                                sx={{
                                  borderRadius: "8px",
                                  px: 1.5,
                                  py: 0.65,
                                  mb: 0.25,
                                  ml: 1,
                                  display: sub.display,
                                  color:
                                    location.pathname === sub.path
                                      ? "#ffffff"
                                      : "#667792",
                                  background:
                                    location.pathname === sub.path
                                      ? "linear-gradient(120deg, #193eaa, #5f51cc)"
                                      : "transparent",
                                  "&:hover": {
                                    background:
                                      location.pathname === sub.path
                                        ? "linear-gradient(120deg, #193eaa, #5f51cc)"
                                        : "#edf2ff",
                                    color:
                                      location.pathname === sub.path
                                        ? "#ffffff"
                                        : "#173b9d",
                                  },
                                  transition: "all 0.2s ease",
                                }}
                              >
                                <Box
                                  sx={{
                                    color:
                                      location.pathname === sub.path
                                        ? "rgba(255,255,255,0.85)"
                                        : "#8493aa",
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "0.75rem",
                                  }}
                                >
                                  {sub.icon}
                                </Box>
                                <ListItemText
                                  sx={{ ml: 1 }}
                                  primary={sub.text}
                                  primaryTypographyProps={{
                                    fontSize: "0.78rem",
                                    fontWeight:
                                      location.pathname === sub.path
                                        ? 600
                                        : 400,
                                    color: "inherit",
                                  }}
                                />
                              </ListItemButton>
                            ))}
                          </Box>
                        </List>
                      </Collapse>
                    </React.Fragment>
                  ) : (
                    <React.Fragment key={item.text}>
                      <ListItemButton
                        onClick={() => navigate(item.path)}
                        sx={{
                          borderRadius: "12px",
                          px: 1.5,
                          py: 0.9,
                          mb: 0.4,
                          color:
                            location.pathname === item.path
                              ? "#ffffff"
                              : "#53627a",
                          background:
                            location.pathname === item.path
                              ? "linear-gradient(120deg, #193eaa, #5f51cc)"
                              : "transparent",
                          border:
                            location.pathname === item.path
                              ? "1px solid transparent"
                              : "1px solid transparent",
                          "&:hover": {
                            background:
                              location.pathname === item.path
                                ? "linear-gradient(120deg, #193eaa, #5f51cc)"
                                : "#f0f4ff",
                            color:
                              location.pathname === item.path
                                ? "#ffffff"
                                : "#173b9d",
                            border:
                              location.pathname === item.path
                                ? "1px solid transparent"
                                : "1px solid #dfe7fa",
                          },
                          transition: "all 0.2s ease",
                        }}
                      >
                        <Box
                          sx={{
                            color:
                              location.pathname === item.path
                                ? "rgba(255,255,255,0.9)"
                                : "#8493aa",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {item.icon}
                        </Box>
                        <ListItemText
                          sx={{ ml: 1 }}
                          primary={item.text}
                          primaryTypographyProps={{
                            fontSize: "0.75rem",
                            fontWeight:
                              location.pathname === item.path ? 600 : 400,
                            color: "inherit",
                          }}
                        />
                        {/* Active indicator */}
                        {location.pathname === item.path &&
                          item.text !== "Centre Referrals" && (
                            <Box
                              sx={{
                                width: 5,
                                height: 5,
                                borderRadius: "50%",
                                background: "rgba(255,255,255,0.8)",
                                flexShrink: 0,
                              }}
                            />
                          )}
                      </ListItemButton>
                    </React.Fragment>
                  ),
                )}
              </List>
            </>
          )}
        </Box>

        {/* ───────── Bottom Profile ───────── */}
        <Box
          sx={{
            borderTop: "1px solid #e4eaf6",
            p: 1.5,
            flexShrink: 0,
            background: "rgba(247,249,255,0.84)",
          }}
        >
          <Box
            role="button"
            tabIndex={0}
            aria-haspopup="menu"
            aria-expanded={Boolean(profileMenuAnchor)}
            aria-label="Open account menu"
            onClick={handleProfileMenuOpen}
            onKeyDown={handleProfileKeyDown}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.25,
              p: "10px 12px",
              borderRadius: "14px",
              background: "rgba(255,255,255,0.85)",
              border: "1px solid #e1e8f7",
              boxShadow: "0 6px 16px rgba(25,62,170,0.05)",
              cursor: "pointer",
              outline: "none",
              transition: "all .25s ease",
              "&:hover": {
                boxShadow: "0 10px 22px rgba(49,87,201,.12)",
                transform: "translateY(-1px)",
                borderColor: "#cbd9f7",
              },
              "&:focus-visible": {
                boxShadow: "0 0 0 3px rgba(49,87,201,.22)",
              },
            }}
          >
            <Avatar
              src={orgLogo || undefined}
              alt="User Avatar"
              sx={{
                width: 38,
                height: 38,
                border: "2px solid rgba(49,87,201,.18)",
                flexShrink: 0,
                bgcolor: "#3157c9",
                color: "#fff",
                fontWeight: 700,
                fontSize: ".9rem",
              }}
            >
              {!orgLogo && userInitial}
            </Avatar>

            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Tooltip title={userName} arrow>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: ".82rem",
                    color: "#223252",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {userName}
                </Typography>
              </Tooltip>

              <Typography
                sx={{
                  fontSize: ".70rem",
                  color: "#7a89a1",
                  mt: 0.3,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {orgName}
              </Typography>
            </Box>

            <KeyboardArrowRightIcon
              fontSize="small"
              sx={{ color: "#70829e", flexShrink: 0 }}
            />
          </Box>

          {/* Profile Menu */}
          <Menu
            anchorEl={profileMenuAnchor}
            open={Boolean(profileMenuAnchor)}
            onClose={handleProfileMenuClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            PaperProps={{
              elevation: 8,
              sx: {
                mt: -0.5,
                minWidth: 238,
                borderRadius: "14px",
                border: "1px solid #e7edf8",
                overflow: "hidden",
                boxShadow: "0 18px 40px rgba(31,54,123,.16)",
                "& .MuiList-root": { py: 0 },
              },
            }}
          >
            <Box
              component="li"
              sx={{
                display: "flex",
                gap: 1.25,
                px: 1.75,
                py: 1.5,
                listStyle: "none",
              }}
            >
              <Avatar
                src={orgLogo || undefined}
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: "#3157c9",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: ".95rem",
                }}
              >
                {!orgLogo && userInitial}
              </Avatar>
              <Box sx={{ minWidth: 0, pt: 0.1 }}>
                <Typography
                  sx={{
                    color: "#223252",
                    fontSize: ".88rem",
                    fontWeight: 700,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {userName}
                </Typography>
                <Typography
                  sx={{
                    color: "#7a89a1",
                    fontSize: ".72rem",
                    mt: 0.25,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {orgName}
                </Typography>
              </Box>
            </Box>
            <Box component="li" sx={{ listStyle: "none" }}>
              <Divider sx={{ borderColor: "#eaf0f8" }} />
            </Box>
            <MenuItem
              onClick={() => {
                handleProfileMenuClose();
                const idParts = (user?.userId || "").split("-");
                navigate("/forgot-password", {
                  state: {
                    userId: user?.userId || "",
                    stateCode: idParts[0] || "",
                    orgCode: idParts[1] || "",
                    userCode: idParts[2] || "",
                  },
                });
              }}
              sx={{
                py: 1.25,
                px: 1.75,
                transition: ".25s",
                "&:hover": {
                  bgcolor: "#f0f4ff",
                },
              }}
            >
              <ListItemIcon>
                <LockResetIcon
                  sx={{
                    color: "#3157c9",
                    fontSize: 20,
                  }}
                />
              </ListItemIcon>

              <ListItemText
                primary="Change Password"
                primaryTypographyProps={{
                  fontSize: ".88rem",
                  fontWeight: 600,
                  color: "#223252",
                }}
              />
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleProfileMenuClose();
                logout();
              }}
              sx={{
                py: 1.25,
                px: 1.75,
                transition: ".25s",
                "&:hover": {
                  bgcolor: "#fff3f3",
                },
              }}
            >
              <ListItemIcon>
                <LogoutIcon
                  sx={{
                    color: "#e53935",
                    fontSize: 20,
                  }}
                />
              </ListItemIcon>

              <ListItemText
                primary="Sign Out"
                primaryTypographyProps={{
                  fontSize: ".88rem",
                  fontWeight: 600,
                  color: "#223252",
                }}
              />
            </MenuItem>
          </Menu>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#f4f6fb" }}
    >
      <CssBaseline />

      {updateAvailable && (
        <Box
          role="status"
          sx={{
            position: "fixed",
            top: { xs: 12, sm: 20 },
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 11001,
            width: { xs: "calc(100% - 32px)", sm: "auto" },
            minWidth: { sm: 360 },
            maxWidth: 460,
            px: 1.5,
            py: 1.25,
            borderRadius: "16px",
            bgcolor: "#202c33",
            border: "1px solid rgba(255,255,255,0.08)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1.5,
            boxShadow: "0 8px 32px rgba(0,0,0,0.45), 0 2px 8px rgba(0,0,0,0.3)",
            backdropFilter: "blur(12px)",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
            {/* Icon bubble */}
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                bgcolor: "#00a884",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                boxShadow: "0 0 0 3px rgba(0,168,132,0.2)",
              }}
            >
              <SystemUpdateAltRoundedIcon
                sx={{ color: "#fff", fontSize: 20 }}
              />
            </Box>

            {/* Text */}
            <Box>
              <Typography
                sx={{
                  fontSize: "0.83rem",
                  fontWeight: 600,
                  color: "#e9edef",
                  lineHeight: 1.3,
                  letterSpacing: "0.1px",
                }}
              >
                Update Available
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  color: "#8696a0",
                  mt: "2px",
                  lineHeight: 1.4,
                }}
              >
                A new version is ready. Refresh to apply.
              </Typography>
            </Box>
          </Box>

          {/* Refresh button */}
          <IconButton
            aria-label="Refresh to update"
            size="small"
            onClick={() => window.location.reload()}
            sx={{
              bgcolor: "#00a884",
              color: "#fff",
              width: 36,
              height: 36,
              flexShrink: 0,
              borderRadius: "50%",
              boxShadow: "0 2px 8px rgba(0,168,132,0.35)",
              transition: "all .3s cubic-bezier(.4,0,.2,1)",
              "&:hover": {
                bgcolor: "#06cf9c",
                transform: "rotate(180deg)",
                boxShadow: "0 4px 14px rgba(0,168,132,0.5)",
              },
            }}
          >
            <RefreshRoundedIcon sx={{ fontSize: "1.1rem" }} />
          </IconButton>
        </Box>
      )}

      {/* ── AppBar ── */}
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          // ✅ starts after the drawer on desktop
          ml: { sm: `${activeDrawerWidth}px` },
          width: { sm: `calc(100% - ${activeDrawerWidth}px)` },
          transition:
            "margin-left 240ms cubic-bezier(.2,.8,.2,1), width 240ms cubic-bezier(.2,.8,.2,1)",
          // ✅ sits BELOW the sidebar (drawer zIndex is 10000)
          zIndex: (theme) => theme.zIndex.drawer - 1,
          backgroundColor: "rgba(255,255,255,0.92)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          borderBottom: "1px solid rgba(229,233,239,0.9)",
          boxShadow: "0 1px 12px rgba(10,31,68,0.06)",
        }}
      >
        <Toolbar sx={{ minHeight: { xs: 56, sm: 64 }, px: { xs: 2, sm: 3 } }}>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{
              display: { sm: "none" },
              color: "#173b9d",
              mr: 1,
              borderRadius: "10px",
              "&:hover": { backgroundColor: "rgba(42,84,166,0.08)" },
            }}
          >
            <MenuIcon />
          </IconButton>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.2,
              }}
            >
              {/* Circular Icon */}
              <Box
                sx={{
                  width: 34,
                  height: 34,
                  borderRadius: "50%",
                  bgcolor: "#eef3ff",
                  color: "#3157c9",
                  border: "1px solid #d7e2fb",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {pageHeader.icon &&
                  React.createElement(pageHeader.icon, {
                    sx: { fontSize: 18 },
                  })}
              </Box>

              {/* Title & Subtitle */}
              <Box>
                <Typography
                  sx={{
                    fontSize: "0.9rem",
                    fontWeight: 700,
                    color: "#223252",
                    lineHeight: 1.15,
                  }}
                >
                  {pageHeader.header}
                </Typography>

                <Typography
                  sx={{
                    fontSize: "0.65rem",
                    color: "#7b889d",
                    lineHeight: 1.2,
                    mt: "1px",
                  }}
                >
                  {pageHeader.subtitle}
                </Typography>
              </Box>
            </Box>

            {/* Org pill */}
            <Box
              sx={{
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
                gap: 1,
                px: 1.5,
                py: 0.6,
                borderRadius: "100px",
                border: "1px solid rgba(42,84,166,0.15)",
                background: "rgba(42,84,166,0.04)",
              }}
            >
              <Avatar
                src={orgLogo || undefined}
                sx={{ width: 22, height: 22 }}
              />
              <Box sx={{ minWidth: 0, maxWidth: 170 }}>
                {isDoctorSession && (
                  <Typography
                    sx={{
                      fontSize: "0.72rem",
                      fontWeight: 700,
                      color: "#223252",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {userName}
                  </Typography>
                )}
                <Typography
                  sx={{
                    fontSize: isDoctorSession ? "0.65rem" : "0.78rem",
                    fontWeight: isDoctorSession ? 500 : 600,
                    color: "#223252",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {orgName}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  background: "#22c55e",
                }}
              />
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      {/* ── Desktop Drawer ── */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          width: activeDrawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: activeDrawerWidth,
            transition: "width 240ms cubic-bezier(.2,.8,.2,1)",
            boxSizing: "border-box",
            border: "none",
            background: "transparent",
            height: "100vh",
            overflow: "hidden",
          },
        }}
        open
      >
        {drawer}
      </Drawer>

      {/* ── Mobile Drawer ── */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            border: "none",
            background: "transparent",
            boxShadow: "8px 0 32px rgba(10,31,68,0.25)",
          },
        }}
      >
        {drawer}
      </Drawer>

      {/* ── Main Content ── */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: { xs: "56px", sm: "64px" },
          p: { xs: "14px", sm: "22px" },
          minHeight: "100vh",
          background: "#f4f6fb",
        }}
      >
        <Routes>
          <Route
            path="/"
            element={
              <PermissionRoute allowed={permissions?.patientManagement?.view}>
                <DashboardInformation />
              </PermissionRoute>
            }
          />
          <Route
            path="patients"
            element={
              <PermissionRoute allowed={permissions?.patientManagement?.view}>
                <Patient />
              </PermissionRoute>
            }
          />
          <Route
            path="bills"
            element={
              <PermissionRoute allowed={permissions?.billManagement?.create}>
                <Bills />
              </PermissionRoute>
            }
          />
          <Route
            path="doctors"
            element={
              <PermissionRoute allowed={permissions?.doctorManagement?.view}>
                <DoctorManagement />
              </PermissionRoute>
            }
          />
          <Route path="test" element={<TestManagement />} />
          <Route
            path="prescription"
            element={
              <DoctorOnlyRoute>
                <PatientPrescriptionForm />
              </DoctorOnlyRoute>
            }
          />
          <Route
            path="patient"
            element={
              <DoctorOnlyRoute>
                <DoctorPatientList />
              </DoctorOnlyRoute>
            }
          />
          <Route path="medicine" element={<MedicineMaster />} />
          <Route
            path="opd"
            element={
              <PermissionRoute allowed={permissions?.opdManagement?.view}>
                <DoctorConsult />
              </PermissionRoute>
            }
          />
          <Route path="lab/pathology" element={<Pathology />} />
          <Route path="lab/radiology" element={<Radiology />} />
          <Route path="lab/microbiology" element={<MicroBiology />} />
          <Route
            path="report/pathology"
            element={
              <PermissionRoute allowed={permissions?.pathologyManagement?.view}>
                <PathologyReports />
              </PermissionRoute>
            }
          />
          <Route
            path="report/radiology"
            element={
              <PermissionRoute allowed={permissions?.radiologyManagement?.view}>
                <RadiologyReports />
              </PermissionRoute>
            }
          />
          <Route
            path="report/microbiology"
            element={
              <PermissionRoute
                allowed={permissions?.microbiologyManagement?.view}
              >
                <MicrobiologyReportsDynamics />
              </PermissionRoute>
            }
          />
          <Route
            path="invoices"
            element={
              <PermissionRoute allowed={permissions?.billManagement?.view}>
                <Invoices />
              </PermissionRoute>
            }
          />
          <Route path="ledger" element={<Ledger />} />
          <Route path="bill-settlement" element={<Accounting />} />
          <Route path="pending-approvals" element={<PendingReports />} />
          <Route path="manualVouchers" element={<ManualVouchers />} />
          <Route path="overview" element={<Overview />} />
          <Route path="products" element={<Products />} />
          <Route path="bom" element={<Bom />} />
          <Route path="receipt" element={<Receipt />} />
          <Route path="cycle-count" element={<CycleCount />} />
          <Route
            path="centre-ref"
            element={
              <PermissionRoute
                allowed={
                  permissions?.billManagement?.create &&
                  permissions?.patientManagement?.create &&
                  permissions?.opdManagement?.create
                }
              >
                <RefPatientList />
              </PermissionRoute>
            }
          />
        </Routes>
      </Box>
    </Box>
  );
};

export default UserDashboard;
